module.exports = __webpack_public_path__ + "media/900_Ares_KSAT45_PersonalizedAttackMethods_2025.e83404e8.mp4";